import "./user-role-personality-fit-report.css";
import { useMemo } from "react";
// Short Report: User vs Role Personality Fit
// const dummyData = {
//   detailedReport: {
//     userDetails: { name: "Daniel Lee" },
//     roleDetails: { name: "Software Engineer" },
//   },
//   personalityFitShortReport: {
//     overallPersonalityFit: "Moderate",
//     lifeVectors: [
//       // 3 aligned
//       { name: "Spirit", match: "aligned", user_trait: "versatile", role_trait: "versatile" },
//       { name: "Rewards", match: "aligned", user_trait: "achievement-oriented", role_trait: "achievement-oriented" },
//       {
//         name: "Profession",
//         match: "aligned",
//         user_trait: "structured working methods",
//         role_trait: "structured working methods",
//       },
//       // 1 not aligned
//       { name: "Purpose", match: "not aligned", user_trait: "security-focused", role_trait: "mission-driven" },
//     ],
//     overview:
//       "Daniel aligns on 3 of 4 personality vectors (75%), showing versatility, achievement orientation, and structured working methods. The single gap is in Purpose: Daniel is security-focused while the role emphasizes being mission-driven. This difference may not impact immediate role performance but could affect long-term motivation. Positioning role goals to connect with his stability needs can help sustain engagement.",
//   },
// }

const UserRolePersonalityFitReport = (props) => {
  console.log("UserRolePersonalityFitReport props:", props);
  const comparisonResult = props?.comparisonData.personalityFitShortReport;

  // const data = comparisonResult?.personalityFitShortReport || {}
  // const userDetails = comparisonResult?.detailedReport?.userDetails || {}
  // const roleDetails = comparisonResult?.detailedReport?.roleDetails || {}

  const userName = comparisonResult?.userName || "";
  const roleName = comparisonResult?.roleName || "";

  const overallFit = comparisonResult.overallPersonalityFit;
  // const lifeVectors = comparisonResult.verticalDetails || [];
  const lifeVectors = useMemo(() => {
    const a = comparisonResult?.personalityFitShortReport?.vectorDetails;
    const b =
      comparisonResult?.detailedReport?.personalityFit?.visualization
        ?.lifeVectors;
    const c = comparisonResult?.vectorDetails; // just in case you flatten it elsewhere
    return [a, b, c].find((v) => Array.isArray(v)) ?? [];
  }, [comparisonResult]);
  // const lifeVectors = [

  //   {
  //     name: "Spirit",
  //     match: "aligned",
  //     user_trait: "versatile",
  //     role_trait: "versatile",
  //   },
  //   {
  //     name: "Rewards",
  //     match: "aligned",
  //     user_trait: "achievement-oriented",
  //     role_trait: "achievement-oriented",
  //   },
  //   {
  //     name: "Profession",
  //     match: "aligned",
  //     user_trait: "structured working methods",
  //     role_trait: "structured working methods",
  //   },

  //   {
  //     name: "Purpose",
  //     match: "not aligned",
  //     user_trait: "security-focused",
  //     role_trait: "mission-driven",
  //   },
  // ];

  const alignedVectors = lifeVectors.filter(
    (vector) => vector.match === "aligned"
  );
  const notAlignedVectors = lifeVectors.filter(
    (vector) => vector.match === "not aligned"
  );

  const alignmentPercentage =
    lifeVectors.length > 0
      ? Math.round((alignedVectors.length / lifeVectors.length) * 100)
      : 0;

  const hasAnyVectors = lifeVectors.length > 0;
  const noAlignedText = hasAnyVectors ? "No aligned vectors" : "No vector data";
  const noNotAlignedText = hasAnyVectors
    ? "No misalignments found"
    : "No vector data";

  const clamp = (v) => Math.max(0, Math.min(100, Number.isFinite(v) ? v : 0));

  return (
    <div className="ur-pf-short-report-container">
      <div className="ur-pf-report-header">
        <h3>Personality Fit for Role</h3>
        <p>
          Assessment of personality alignment between user and role success
          profile
        </p>
      </div>

      <div className="ur-pf-comparison-summary">
        <div className="ur-pf-summary-card">
          <div className="ur-pf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="ur-pf-summary-content">
            <div className="ur-pf-summary-value">{overallFit}</div>
            <div className="ur-pf-summary-label">Overall Personality Fit</div>
          </div>
        </div>

        <div className="ur-pf-summary-card">
          <div className="ur-pf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 12l2 2 4-4" />
              <circle cx="12" cy="12" r="10" />
            </svg>
          </div>
          <div className="ur-pf-summary-content">
            <div className="ur-pf-summary-value">{alignedVectors.length}</div>
            <div className="ur-pf-summary-label">Vectors Aligned</div>
          </div>
        </div>

        <div className="ur-pf-summary-card">
          <div className="ur-pf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <div className="ur-pf-summary-content">
            <div className="ur-pf-summary-value">
              {notAlignedVectors.length}
            </div>
            <div className="ur-pf-summary-label">Vector Not Aligned</div>
          </div>
        </div>

        <div className="ur-pf-summary-card">
          <div className="ur-pf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div className="ur-pf-summary-content">
            <div className="ur-pf-summary-value">{userName}</div>
            <div className="ur-pf-summary-label">User Profile</div>
          </div>
        </div>
      </div>

      {/* Personality Vectors Comparison */}
      <div className="ur-pf-metrics-comparison">
        <h3>Personality Vectors Alignment</h3>
        <div className="ur-pf-vectors-pills">
          <div className="ur-pf-vectors-section">
            <span className="ur-pf-vectors-label">Aligned vectors:</span>
            <div className="ur-pf-pills-container">
              {alignedVectors.length > 0 ? (
                alignedVectors.map((vector, index) => (
                  <span key={index} className="ur-pf-pill ur-pf-pill-aligned">
                    {vector.name}
                  </span>
                ))
              ) : (
                <span className="ur-pf-empty-hint">{noAlignedText}</span>
              )}
            </div>
          </div>

          <div className="ur-pf-vectors-section">
            <span className="ur-pf-vectors-label">Not aligned:</span>
            <div className="ur-pf-pills-container">
              {notAlignedVectors.length > 0 ? (
                notAlignedVectors.map((vector, index) => (
                  <span key={index} className="ur-pf-pill ur-pf-pill-missing">
                    {vector.name}
                  </span>
                ))
              ) : (
                <span className="ur-pf-empty-hint">{noNotAlignedText}</span>
              )}
            </div>
          </div>
        </div>

        <h3 style={{ marginTop: "24px" }}>Personality Alignment Score</h3>
        <div className="ur-pf-metrics-chart">
          <div className="ur-pf-metric-bar-container">
            <div className="ur-pf-metric-info">
              <span className="ur-pf-metric-name">Overall Personality Fit</span>
            </div>
            <div className="ur-pf-metric-bar">
              <div
                className="ur-pf-metric-fill"
                style={{ width: `${clamp(alignmentPercentage)}%` }}
              />
              <span className="ur-pf-metric-value">{`${alignmentPercentage}%`}</span>
            </div>
          </div>
        </div>

        {/* Detailed Vector Breakdown */}
        {lifeVectors.length > 0 && (
          <div className="ur-pf-vectors-details">
            <h3>Vector Details</h3>
            {/* NEW wrapper: turns the list into a 2×2 grid */}
            <div className="ur-pf-vectors-grid">
              {lifeVectors.map((vector, index) => (
                <div key={index} className="ur-pf-vector-detail">
                  <div className="ur-pf-vector-header">
                    <span className="ur-pf-vector-name">{vector.name}</span>
                    <span
                      className={`ur-pf-vector-status ${
                        vector.match === "aligned"
                          ? "ur-pf-aligned"
                          : "ur-pf-not-aligned"
                      }`}
                    >
                      {vector.match}
                    </span>
                  </div>
                  <div className="ur-pf-vector-traits">
                    <span className="ur-pf-trait-label">
                      User: {vector.user_trait}
                    </span>
                    <span className="ur-pf-trait-label">
                      Role: {vector.role_trait}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Analysis Overview */}
      <div className="ur-pf-insights-section">
        <h3>Analysis Overview</h3>
        <div className="ur-pf-analysis-paragraph">
          <p>{props.comparisonData.personalityFitShortReport.overview}</p>
        </div>
      </div>
    </div>
  );
};

export default UserRolePersonalityFitReport;
